import React from 'react';
import { Route as ReactRoute } from 'react-router-dom';

const Route = ({component, container: Container, render, ...rest }) => {
  const Component = render || component;
  return <ReactRoute {...rest} render={(props) => (
      Container
        ? <Container {...props}><Component {...props} /></Container>
        : <Component {...props} />
    )} />
}

export default Route;


// WEBPACK FOOTER //
// ./src/components/helpers/router/Route.js